"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RouterLink = exports.DisabledItem = exports.AnchorLink = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRouterDom = require("react-router-dom");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _objects = require("../../utils/objects");
var _utils = require("./utils");
var _excluded = ["link", "children", "className"],
  _excluded2 = ["children"],
  _excluded3 = ["link", "children"];
var OpenIcon = function OpenIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 5c0-1.102.898-2 2-2h7a1 1 0 1 1 0 2H5v14h14v-7a1 1 0 1 1 2 0v7c0 1.102-.898 2-2 2H5c-1.102 0-2-.898-2-2V5zm12-1a1 1 0 0 1 1-1h3.99a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6.431l-6.22 6.283a1 1 0 0 1-1.42-1.408L17.592 5H16a1 1 0 0 1-1-1z"
  }));
};
OpenIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "header": "header_3stP4D",
  "item": "item_2Lgj-5",
  "hierarchy-2": "hierarchy-2_1G9wOz",
  "hierarchy2": "hierarchy-2_1G9wOz",
  "active": "active_3u2LpW",
  "content": "content_3F7i8X",
  "label": "label_jpQx30",
  "annotation": "annotation_20x4VE",
  "item-move": "item-move_3Ba0qn",
  "itemMove": "item-move_3Ba0qn",
  "hidden": "hidden_3Rmit_",
  "open-icon": "open-icon_1M0HPq",
  "openIcon": "open-icon_1M0HPq",
  "icon": "icon_J-WQsp",
  "error": "error_3327M8",
  "suffix": "suffix_2lvjBy",
  "disabled": "disabled_3yRSJM"
}; 
require('./SidebarItem.css');
var RouterLink = exports.RouterLink = function RouterLink(_ref) {
  var _ref$link = _ref.link,
    isActive = _ref$link.isActive,
    to = _ref$link.to,
    children = _ref.children,
    className = _ref.className,
    commonProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (
    /*#__PURE__*/
    /* As we cannot cannot control isActive manually, we don't provide an activeClassName if link is not active */
    _react.default.createElement(_reactRouterDom.NavLink, (0, _extends2.default)({
      to: to,
      activeClassName: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.active, isActive === undefined), 'is-active', isActive === undefined)),
      className: (0, _classnames.default)(className, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.active, isActive), 'is-active', isActive))
    }, commonProps), children)
  );
};
var DisabledItem = exports.DisabledItem = function DisabledItem(_ref2) {
  var children = _ref2.children,
    commonProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement("span", (0, _objects.omit)(commonProps, 'link', 'exact'), children);
};
var AnchorLink = exports.AnchorLink = function AnchorLink(_ref3) {
  var _ref3$link = _ref3.link,
    href = _ref3$link.href,
    target = _ref3$link.target,
    children = _ref3.children,
    commonProps = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: href,
    target: target
  }, (0, _objects.omit)(commonProps, 'exact')), children, target === '_blank' ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.openIcon,
    size: "xxs"
  }, /*#__PURE__*/_react.default.createElement(OpenIcon, null)) : null);
};
var SidebarItem = function SidebarItem(_ref4) {
  var className = _ref4.className,
    href = _ref4.href,
    target = _ref4.target,
    to = _ref4.to,
    hierarchy = _ref4.hierarchy,
    isActive = _ref4.isActive,
    isDisabled = _ref4.isDisabled,
    onClick = _ref4.onClick,
    icon = _ref4.icon,
    children = _ref4.children,
    title = _ref4.title,
    annotation = _ref4.annotation,
    draggable = _ref4.draggable,
    suffix = _ref4.suffix,
    exact = _ref4.exact,
    testId = _ref4.testId;
  var ItemComponent;
  if (isDisabled) {
    ItemComponent = DisabledItem;
  } else if (href !== undefined) {
    ItemComponent = AnchorLink;
  } else {
    ItemComponent = RouterLink;
  }
  return /*#__PURE__*/_react.default.createElement(ItemComponent, {
    "data-test-id": testId !== null && testId !== void 0 ? testId : 'sidebar-link',
    className: (0, _classnames.default)(className, styles.item, hierarchy ? styles["hierarchy-".concat(hierarchy)] : null, isActive ? styles.active : null, isDisabled ? styles.disabled : null),
    draggable: draggable,
    link: {
      isActive: isActive,
      to: to,
      href: href,
      target: target
    },
    onClick: onClick,
    exact: exact
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.content
  }, (0, _utils.getIcon)(icon), /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "item-move-dots",
    className: (0, _classnames.default)(styles.itemMove, (0, _defineProperty2.default)({}, styles.hidden, !draggable))
  }), /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "link-label",
    className: styles.label,
    title: title
  }, children, !!annotation ? /*#__PURE__*/_react.default.createElement("span", {
    className: styles.annotation
  }, annotation) : null)), !!suffix ? /*#__PURE__*/_react.default.createElement("span", {
    className: styles.suffix
  }, suffix) : null);
};
var _default = exports.default = SidebarItem;
//# sourceMappingURL=SidebarItem.js.map